import React, { FC, PropsWithChildren } from 'react';

import './style.css';
import '../../../styles/elements/button.css';

/** Main slider component. */
const MainSliderElement: FC<PropsWithChildren> = props => <div className="slider-item">{props.children}</div>;

export default MainSliderElement;
